import React from 'react';

import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

import { useSelectAdvancedWithGroupingContext } from './SelectAdvancedWithGroupingContext';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  gap: 10px;
  align-items: center;
  padding: 6px 10px;
`;

const Label = styled.div`
  display: inline-block;
  max-width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

interface SelectionRowProps {
  label: string;
  checked: boolean;
  id: number;
  disabled?: boolean;
}

const SelectionRow = ({ label, checked, id, disabled = false }: SelectionRowProps) => {
  const { addItemsToSelectedGroupOptions, removeItemsFromSelectedGroupOptions } =
    useSelectAdvancedWithGroupingContext();

  const onRowClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (disabled) {
      return;
    }

    if (checked) {
      removeItemsFromSelectedGroupOptions([id]);
    } else {
      addItemsToSelectedGroupOptions([id]);
    }
  };
  return (
    <Container onClick={onRowClick} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <Checkbox disabled={disabled} checked={checked} className={'green'} />
      <Label title={label}>{label}</Label>
    </Container>
  );
};

export default SelectionRow;
